// eslint-disable-next-line no-undef
jQuery(function ($) {
  var $html = $('html').removeClass('no-js');

  $html.deepLinks()
  $('form input[id^="your-name_"]').attr('autocomplete', 'chrome-off')

  if (!$.supports.touch) {
		$('select[multiple]').multiselect();
	}

// ADD ALL YOUR CUSTOM JS THINGS AFTER THIS LINE
	$html.on({
		ready: function() {
			$(document).scrollTop($(this).prev().offset().top - $('.container-header').height());
		}
	}, '.posttypelist_training');

	let search = document.getElementsByClassName("widget_search__icon")[0];
	let search_widget = document.getElementsByClassName("top-search")[0];
	let canvas = document.querySelector("div.canvas");
	let buttonTop = document.getElementsByClassName("scroll-top-button")[0];
	let scrollTop;

	document.addEventListener("mousedown", (event) => {
		if(search && search.contains(event.target)) {
			scrollTop = $(window).scrollTop()

			console.log(scrollTop)

			if(canvas.className === "canvas") {
				canvas.classList.add("top_container-search");
				search_widget.style.top = scrollTop + "px";
			} else {
				canvas.classList.remove("top_container-search");
				//search_widget.style.top = 0;
			}
		} else if(buttonTop && buttonTop.contains(event.target)) {
			$(window).scrollTop(0);
		}
	})

	$(window).scroll(function () {
		scrollTop = $(window).scrollTop()
		if(scrollTop > 0 && canvas.className !== "canvas") {
			canvas.classList.remove("top_container-search");
			//search_widget.style.top = 0;
		}
	})

	if(document.getElementsByClassName('post-accordion').length > 0) {
		let acc = document.getElementsByClassName('article__header');

		for(let i = 0; i < acc.length; i++) {
			acc[i].addEventListener("click", function() {
				this.classList.toggle("active");
				let panel = this.nextElementSibling;
				if(panel.style.maxHeight) {
					panel.style.maxHeight = null;
				}
				else {
					panel.style.maxHeight = panel.scrollHeight + 'px';
				}
			});
		}
	}


	$('.posttypelist_event-widget .article__link').click(function() {
		let acc = document.querySelectorAll('.post-accordion > .article__header');
		acc[acc.length-1].classList.toggle("active");

		let panel = acc[acc.length-1].nextElementSibling;
		panel.style.maxHeight = panel.scrollHeight + 'px';
		document.documentElement.scrollTop = (acc[acc.length-1].getBoundingClientRect().top + document.documentElement.scrollTop - document.querySelector('.container-header').offsetHeight);

		return false;
	});

	if(document.getElementsByClassName('post-tab-menu').length > 0) {
		document.getElementsByClassName('post-tab-menu')[0].previousElementSibling.previousElementSibling.checked = true
	}

	$('body').on({
		change: function() {
			var value = $(this).val().split('|');
			$('input[id^="DataKursDauerVon_"]').val(value[0]);
			$('input[id^="DataKursDauerBis_"]').val(value[1]);
			$('input[id^="DataKursKursNr_"]').val(value[2]);

			$(this).parents('form').find('.basic-data dd').eq(0).text(value[2]);
			$(this).parents('form').find('.basic-data dd').eq(2).text(value[0].split('-').reverse().join('.') + ' - ' + value[1].split('-').reverse().join('.'));
		}
	}, '[id*="training_date_"]');
	$('.tab-list').each(function() {
		$([
			$(this).find('[id*="training_date_"]:checked').get(0),
			$(this).find('[id*="training_date_"]').get(0)
		].filter(function(e){return e!=null})).eq(0).attr('checked', true).change();
	});

	/** Text to Speech for Magazine*/
	var $links = $('.pagecreator_posttypelist--audio a.article__link');
	if ('speechSynthesis' in window) {
		var playing_class = 'playing';
		var readBlogPost = function() {
			if($(this).data('blogpost')) { // already initialized speach
				if(!window.speechSynthesis.paused) {
					window.speechSynthesis.pause();
					$(this).removeClass(playing_class).find('span').text($(this).data('text'));
				}
				else {
					window.speechSynthesis.resume();
					$(this).addClass(playing_class).find('span').text('Vorlesen anhalten');
				}
			}
			else {
				var blogpost = new SpeechSynthesisUtterance($('.pagecreator_group').eq(0).children().slice(0, -3).text().replace(/\s{2,}/g, ' '));
				blogpost.lang = "de-DE";
				window.speechSynthesis.speak(blogpost);

				$(this).data('blogpost', blogpost);
				$(this).data('text', $(this).find('span').text());
				$(this).addClass(playing_class).find('span').text('Vorlesen anhalten');
			}

			return false;
		};

		$links.click(readBlogPost);
	} else {
		$links.hide();
	}


	// We can attach the `fileselect` event to all file inputs on the page
	$(document).on('change', ':file', function() {
		var input = $(this),
			numFiles = input.get(0).files ? input.get(0).files.length : 1,
			labels = [];

		for(var i = 0; i < input.get(0).files.length; i++) {
			labels.push(input.get(0).files[i].name);
		}

		var label = labels.join(', ').replace(/\\/g, '/').replace(/.*\//, '');

		input.trigger('fileselect', [numFiles, label]);
	});

	$(document).on('dragover dragenter dragleave', ':file', function(e) {
		e.preventDefault();
		e.stopPropagation();
	})
		.on('dragover dragenter', ':file', function() {
			$(this).parent().addClass('is-dragover');
		})
		.on('dragleave dragend drop', ':file', function() {
			$(this).parent().removeClass('is-dragover');
		});

	// We can watch for our custom `fileselect` event like this
	$(document).ready(function() {
		$(':file').on('fileselect', function(event, numFiles, label) {
			var input = $(this).parents('label');

			if(input.length && label) {
				input.attr('data-text', label);
			}

		});
	});

	//prevent radiobuttons to bubble after change-event
	$('[type="radio"][name*="event_date"]').change(function(e){e.stopPropagation();})


	/**
	 * duplicate Participants Group
	 * */
	$('.pagecreator_group + .pagecreator_wysiwygeditor a[data-action=duplicate-group]').click(function(event) {
		event.preventDefault();
		var $group = $(this).closest('.pagecreator_wysiwygeditor').prev();
		var $new = $group.clone();
		$new.find('input').val('');
		$new.find('input[name], select[name]').each(function() {
			var index = $(this).attr('name').match(/\.(\d+)\./);
			if(index.length < 2) return;
			var name = $(this).attr('name');
			name = name.replace(/\.\d+\./, '.' + (parseInt(index[1]) + 1) + '.');
			$(this).attr('name', name);
		});
		// Increase the first number in the blocks headline.
		$new.find('h1,h2,h3').each(function() {
			var $headline = $(this);
			var text = $headline.text();
			var index = text.match(/\d+/);
			if(index === null) return;
			index = parseInt(index[0])
			text = text.replace(/\d+/, index + 1)
			$headline.text(text);
		})
		$new.insertAfter($group);
	});
});
